/** Max allowed from/to range for external trade filters (in years). */
export const MAX_EXTERNAL_TRADE_RANGE_YEARS = 5;

/**
 * Returns true when the selected month range is longer than the allowed max.
 * Month difference equals maxYears * 12 is still allowed.
 */
export const isDateRangeExceedsMaxYears = (
  fromYear,
  fromMonth,
  toYear,
  toMonth,
  maxYears = MAX_EXTERNAL_TRADE_RANGE_YEARS
) => {
  if (!fromYear || !fromMonth || !toYear || !toMonth) {
    return false;
  }

  const fromDate = new Date(+fromYear, +fromMonth - 1, 1);
  const toDate = new Date(+toYear, +toMonth - 1, 1);

  const monthsDiff =
    (toDate.getFullYear() - fromDate.getFullYear()) * 12 +
    (toDate.getMonth() - fromDate.getMonth());

  return monthsDiff > maxYears * 12;
};
